import {useSelector} from 'react-redux';

/**
 * The company's Treezor banking state (drives the card-verification spinner-vs-404 branch).
 * @returns {Object|null}
 */
export const useBankingCompanyState = () => useSelector(state => state.banking.companyState);
